module.exports = __webpack_public_path__ + "static/img/2016-05-21 20.28.19.e380eeb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cabins/main/2016-05-21 20.28.19.jpg
// module id = WshX
// module chunks = 4